import { useTranslation } from 'react-i18next';
import { Block, ScannerInput } from '@uni-space/uni-components';
import { getParcelLabel } from '../api';
import { useLabelPrinter } from '@shared/labels';

export default function ParcelLabel() {
  const { t, i18n } = useTranslation();

  const { isLabelLoading, printLabelFromFetcher } = useLabelPrinter({
    errorTitle: t('common.systemError.title'),
    fallbackErrorMessage: t('common.systemError.desc'),
  });

  const handleSubmit = async (value: string) => {
    await printLabelFromFetcher(() => getParcelLabel(value));
  };

  return (
    <Block mH={8}>
      <ScannerInput
        lang={i18n.language}
        label={t('parcelLabel.scanner.trackNumber')}
        buttonLabel={t('send')}
        isLoading={isLabelLoading}
        disabled={isLabelLoading}
        onSubmit={handleSubmit}
      />
    </Block>
  );
}
